export default __webpack_public_path__ + "assets/linkedin.8cda671e.svg";